import React from "react";
import { CustomIcons } from "./CustomIcons";
import { t } from "i18next";

export const createCustomColumns = ({
    setLimit,
    userData,
    setSaleSupport,
    setIsAddSaleSupportClicked,
    setIsModalConfirmationOpened,
    isModalConfirmationOpened,
    setSelectedRows,
    isArchivedSaleSupportClicked,
    isFavoriteModified,
    setIsFavoriteModified,
    setRowData,
    setIsConsult,
    setDataState,
    setSalesModesTypesAndTag,
}: any) => {
    return [
        {
            indexOFColumn: 4,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIcons
                    setLimit={setLimit}
                    selectedRowData={e}
                    userData={userData}
                    setSaleSupport={setSaleSupport}
                    setIsAddSaleSupportClicked={setIsAddSaleSupportClicked}
                    setIsModalConfirmationOpened={setIsModalConfirmationOpened}
                    isModalConfirmationOpened={isModalConfirmationOpened}
                    setSelectedRows={setSelectedRows}
                    isArchivedSaleSupportClicked={isArchivedSaleSupportClicked}
                    isFavoriteModified={isFavoriteModified}
                    setIsFavoriteModified={setIsFavoriteModified}
                    setRowData={setRowData}
                    setIsConsult={setIsConsult}
                    setDataState={setDataState}
                    setSalesModesTypesAndTag={setSalesModesTypesAndTag}
                />
            ),
        },
    ];
};
